import { formatReferenceItemsLabel } from "../TaggingPlan/ClassificationCascadePicker";

const REFERENCE_DOC_TYPE_DISPLAY = "DocType";

/**
 * Same format as Add/Edit Reference Items cascade:
 * `Insight·DocType = Regulation`, or just the type name when no subtype.
 */
export function formatOtoCascadeItemsLabel(
  typeName: string,
  subTypeName: string,
  subTypeCode = "",
): string {
  const type = typeName.trim();
  const subName = subTypeName.trim();
  if (!type) return "";
  if (!subName) return type;
  return formatReferenceItemsLabel(type, REFERENCE_DOC_TYPE_DISPLAY, [
    {
      id: subTypeCode.trim() || subName,
      code: subTypeCode.trim() || subName,
      name: subName,
    },
  ]);
}
